function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-fa8661be\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ygg9q74r7h!./Step2.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ygg9q74r7h!./Step2.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-fa8661be\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=ygg9q74r7h!./Step2.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa8661be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/product/Step2.vue
// module id = 417
// module chunks = 2